import { useContext } from 'react';
import {
  NotificationContext,
  NotificationContextValue,
} from '../providers/NotificationProvider';

export const useNotification = () =>
  useContext<NotificationContextValue>(NotificationContext);
